export default "1024px"